import logo from './logo.svg';
import './App.css';
import Mainrouteweb from './Routes/Mainrouteweb';
import {
  BrowserRouter as Router,
  Routes, Route
} from "react-router-dom";
import './globle.css'

function App() {
  return (
    <Router>
      <Routes>
       

        <Route path='/*' element={<Mainrouteweb/>}/>


      </Routes>
      
    </Router>
  );
}

export default App;
